import './Resume.css';
import { useEffect, useState, useRef } from 'react';
import ProfilePhoto from './IMAGE/CHRISTIAN.jpeg';
import html2pdf from 'html2pdf.js';

function Resume({ onNavigateHome }) {
  const [zoom, setZoom] = useState(0.75);
  const resumeRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePrint = async () => {
    const element = resumeRef.current;
    if (!element) return;

    // Temporarily reset zoom so html2canvas captures at true size
    const prevZoom = zoom;
    setZoom(1);

    // Wait for React to re-render at zoom = 1
    await new Promise(resolve => setTimeout(resolve, 300));

    const w = element.scrollWidth;
    const h = element.scrollHeight;

    const opt = {
      margin:       0,
      filename:     'Christian_Kalaw_Resume.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2, useCORS: true, logging: false, width: w, height: h },
      jsPDF:        { unit: 'px', format: [w, h], hotfixes: ['px_scaling'] }
    };

    await html2pdf().set(opt).from(element).save();

    // Restore original zoom
    setZoom(prevZoom);
  };

  const zoomIn = () => setZoom(prev => Math.min(1.5, prev + 0.1));
  const zoomOut = () => setZoom(prev => Math.max(0.3, prev - 0.1));
  const zoomReset = () => setZoom(0.75);

  return (
    <div className="resume-page">

      {/* ── Header ── */}
      <header className="resume-header">
        <div className="resume-header-inner">
          <button className="resume-back-btn" onClick={onNavigateHome}>
            <span className="resume-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="resume-breadcrumb">
            <span className="resume-breadcrumb-home" onClick={onNavigateHome}>Home</span>
            <span className="resume-breadcrumb-sep">/</span>
            <span className="resume-breadcrumb-current">Resume</span>
          </nav>
        </div>
      </header>

      {/* ── Controls bar ── */}
      <div className="resume-controls">
        <button className="resume-print-btn" onClick={handlePrint}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Export PDF
        </button>
        <div className="resume-zoom-bar">
          <button className="resume-zoom-btn" onClick={zoomOut} title="Zoom out">−</button>
          <span className="resume-zoom-level">{Math.round(zoom * 100)}%</span>
          <button className="resume-zoom-btn" onClick={zoomIn} title="Zoom in">+</button>
          <button className="resume-zoom-reset" onClick={zoomReset} title="Reset zoom">Reset</button>
        </div>
      </div>

      {/* ── Resume Page ── */}
      <div className="resume-doc-wrapper">
        <div className="resume-doc" ref={resumeRef} style={{ transform: `scale(${zoom})` }}>

        {/* ════ SIDEBAR ════ */}
        <aside className="rv-sidebar">

          <div className="rv-sb-profile">
            <img src={ProfilePhoto} alt="Christian Kalaw" className="rv-sb-avatar" />
            <div className="rv-sb-name"><span>Christian</span> D. Kalaw</div>
            <div className="rv-sb-role">BS Computer Engineering<br />3rd Year · FAITH Colleges</div>
            <div className="rv-sb-open">Open to Opportunities</div>
          </div>

          {/* Personal Information */}
          <div>
            <div className="rv-sb-label">Personal Information</div>
            <div className="rv-sb-info">
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">Address</span>
                <span className="rv-sb-info-val">Lipa, Batangas, Philippines</span>
              </div>
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">Contact No.</span>
                <span className="rv-sb-info-val">0939 853 3885</span>
              </div>
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">Email</span>
                <span className="rv-sb-info-val" style={{ wordBreak: 'break-all' }}>christiankalaw26@gmail.com</span>
              </div>
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">Program</span>
                <span className="rv-sb-info-val">BS Computer Engineering </span>
              </div>
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">Year Level</span>
                <span className="rv-sb-info-val">3rd Year (2022 – 2026)</span>
              </div>
              <div className="rv-sb-info-row">
                <span className="rv-sb-info-key">School</span>
                <span className="rv-sb-info-val">FAITH Colleges, Batangas</span>
              </div>
            </div>
          </div>

          {/* Core Skills */}
          <div>
            <div className="rv-sb-label">Core Skills</div>
            <div className="rv-sb-skills">
              {[
                'Verilog / VHDL',
                'Python / MicroPython',
                'HTML / CSS / JavaScript',
                'React.js',
                'C / C++ / Arduino',
                'ESP32 / Embedded',
                'Firebase / Node.js',
              ].map((label) => (
                <div className="rv-sb-skill-item" key={label}>
                  <div className="rv-sb-skill-label">{label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Tools */}
          <div>
            <div className="rv-sb-label">Tools &amp; Platforms</div>
            <div className="rv-sb-tags">
              {['Quartus Prime', 'Vivado / ISE', 'Wokwi', 'Arduino IDE', 'Cisco PT', 'Git / GitHub', 'FastAPI', 'KiCad / PCB', 'MATLAB', 'OpenCV'].map(t => (
                <span className="rv-sb-tag" key={t}>{t}</span>
              ))}
            </div>
          </div>

          {/* Achievements — compact sidebar version */}
          <div>
            <div className="rv-sb-label">Achievements</div>
            <div className="rv-sb-achlist">
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>Dean's Lister — FAITH Colleges · 2023–2025</div>
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>Merit Award — APEC Schools · 2023</div>
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>Champion — Division Press Conference (Sports Writing) · 2016</div>
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>2nd Place — Regional Press Conference (Sports Writing) · 2016</div>
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>With High Honors — Langka Elementary · 2012</div>
            </div>
          </div>

          {/* Leadership */}
          <div>
            <div className="rv-sb-label">Leadership</div>
            <div className="rv-sb-achlist">
              <div className="rv-sb-ach"><span className="rv-sb-ach-dot"></span>3rd Year Representative — CPE-3A · 2024–Present</div>
            </div>
          </div>

        </aside>

        {/* ════ MAIN ════ */}
        <main className="rv-main">
          {/* Accent line */}
          <div className="rv-accent-line"></div>

          {/* 01 OBJECTIVE */}
          <div className="rv-section">
            <div className="rv-sec-hd">
              <span className="rv-sec-num">01</span>
              <span className="rv-sec-title">Objective</span>
              <div className="rv-sec-rule"></div>
            </div>
            <p className="rv-objective">
              I am <strong>Christian D. Kalaw</strong>, a 3rd-year BS Computer Engineering student at FAITH Colleges, driven by a passion for the intersection of hardware and software. I seek to apply my expertise in <strong>FPGA design, embedded systems, and full-stack web development</strong> to real-world challenges. My goal is to grow as a <strong>Software Developer</strong> who builds scalable, high-impact solutions — contributing meaningfully to a dynamic team while continuing to sharpen my technical skills across digital logic, microcontroller systems, and modern software stacks.
            </p>
          </div>

          {/* 02 EDUCATION */}
          <div className="rv-section">
            <div className="rv-sec-hd">
              <span className="rv-sec-num">02</span>
              <span className="rv-sec-title">Education</span>
              <div className="rv-sec-rule"></div>
            </div>
            <div className="rv-ed">
              <div className="rv-ed-dot"></div>
              <div style={{ flex: 1 }}>
                <div className="rv-ed-head">
                  <span className="rv-ed-title">BS Computer Engineering</span>
                  <span className="rv-ed-badge">2022 — 2026</span>
                </div>
                <div className="rv-ed-org">FAITH Colleges</div>
                <ul className="rv-ed-list">
                  <li>Currently in 3rd year with focus areas in digital systems, embedded systems, and computer architecture.</li>
                  <li>Coursework: Digital Logic Design, Embedded Systems, Data Structures &amp; Algorithms, Web Development, Engineering Economics, Differential Equations, Computer Organization &amp; Architecture, PCB Design.</li>
                  <li>Active in laboratory projects involving FPGA development, microcontroller programming, computer vision, and PCB circuit design.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 03 SKILLS */}
          <div className="rv-section">
            <div className="rv-sec-hd">
              <span className="rv-sec-num">03</span>
              <span className="rv-sec-title">Skills</span>
              <div className="rv-sec-rule"></div>
            </div>
            <div className="rv-strengths-grid">
              <div className="rv-str-card">
                <span className="rv-str-badge">Hardware</span>
                <div className="rv-str-name">FPGA &amp; Digital Design</div>
              </div>
              <div className="rv-str-card">
                <span className="rv-str-badge">Embedded</span>
                <div className="rv-str-name">Embedded &amp; IoT Systems</div>
              </div>
              <div className="rv-str-card">
                <span className="rv-str-badge">Software</span>
                <div className="rv-str-name">Full-Stack Web Dev</div>
              </div>
            </div>
          </div>

          {/* 04 PROJECTS */}
          <div className="rv-section">
            <div className="rv-sec-hd">
              <span className="rv-sec-num">04</span>
              <span className="rv-sec-title">Key Projects</span>
              <div className="rv-sec-rule"></div>
            </div>
            <div className="rv-proj-grid">
              {[
                { cat: 'CPE-CP1', title: 'Snake & Ladder Game' },
                { cat: 'CPE-CP2', title: 'Sign Language Recognition System (Python)' },
                { cat: 'CPE-MAT', title: '3D Heat Conduction on Metal Plates (PDE)' },
                { cat: 'CPE-OOP', title: 'MicroLab Inventory Management System' },
                { cat: 'CPE-DES', title: 'Two-Digit Decimal Counter PCB Design' },
                { cat: 'ECE-DSP', title: 'Voice-Controlled LED System (ESP32 + FFT)' },
                { cat: 'Research', title: 'Graduate Tracer Study of CPE Graduates' },
                { cat: 'CPE-HDL', title: 'Secure Digital Lock System (ABV Verification)' },
                { cat: 'CPE-DS', title: 'Restaurant Web App' },
                { cat: 'EMBEDDED SYSTEM', title: 'Smart Room Access & Status Indication' },
                { cat: 'EMBEDDED SYSTEM', title: 'Sumo Bot' },
                { cat: 'FEEDBACK AND CONTROL SYSTEM', title: 'Ambient Light-Based Smart Lighting System' },
              ].map(({ cat, title }) => (
                <div className="rv-pc" key={title}>
                  <div className="rv-pc-cat">{cat}</div>
                  <div className="rv-pc-title">{title}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 05 SEMINARS */}
          <div className="rv-section">
            <div className="rv-sec-hd">
              <span className="rv-sec-num">05</span>
              <span className="rv-sec-title">Seminars <span style={{fontFamily: "'Inter', sans-serif"}}>&amp;</span> Trainings</span>
              <div className="rv-sec-rule"></div>
            </div>
            <div className="rv-sem-list">
              <div className="rv-sem-item">
                <div className="rv-sem-title">Building Sustainable Future: Empowering Communities through HIV Awareness and Education</div>
                <div className="rv-sem-meta">Seminar Participation</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">Building Intelligence: Where Computer Engineering Meets Data Science</div>
                <div className="rv-sem-meta">Webinar · November 2025</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">Design of RISC-V Microprocessors</div>
                <div className="rv-sem-meta">Webinar · November 8, 2025</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">Arduino Workshop Part 1: Arduino Coding Skills Preparation for Hardware</div>
                <div className="rv-sem-meta">FAITH Computer Engineering Society · September 6, 2025</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">Engineering the Future: Career Stories and Industry Insights</div>
                <div className="rv-sem-meta">First Asia Institute of Technology and Humanities, Tanauan City · March 29, 2025</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">Arduino Workshop Part 2: Integration of Hardware</div>
                <div className="rv-sem-meta">FAITH Computer Engineering Society · September 24, 2025</div>
              </div>
              <div className="rv-sem-item">
                <div className="rv-sem-title">3rd Annual Conference of the Center for Integrated Circuit and Device Research (CIDR)</div>
                <div className="rv-sem-meta">Novotel, Araneta City, Quezon City · August 11-12, 2025</div>
              </div>
            </div>
          </div>

        </main>
      </div>
      </div>

      {/* FOOTER — on the page, not inside the resume card */}
      <div className="rv-footer">
        <span>CHRISTIAN D. KALAW · BSCPE · FAITH COLLEGES</span>
        <span>© {new Date().getFullYear()}</span>
      </div>

    </div>
  );
}

export default Resume;
